import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae357d06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sw-popular-works-section--title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "人気作品")
], -1))
const _hoisted_3 = { class: "sw-popular-works-section--body" }

import {
  computed,
  ref,
  onMounted,
  onUnmounted,
  toRefs,
  watch,
  withDefaults,
} from 'vue';
import SwWorksSection from '@/components/organisms/Sections/SwWorksSection.vue';
import {
  Forms,
  Genres,
  Productions,
  SortOrder,
} from '@/api/spotwrite';
import useMediaQueriyFunc from '@/components/utils/MediaQuery';
import ProductionService, { PuroductionsSearchCondition } from '@/api/ProductionService';
import PopularProductionService, { PopularPuroductionsSearchCondition } from '@/api/PopularProductionService';

interface Props {
  genre?: Genres;
  form?: Forms;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SwPopularWorksSection',
  props: {
    genre: { default: undefined },
    form: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { genre: Genres, form: Forms }

const { lg, md, sm } = useMediaQueriyFunc();



const { form, genre } = toRefs(props);

/**
 * class 属性
 */
const classes = computed(() => ({
  'sw-popular-works-section': true,
}));

/**
 * 人気の投稿作品
 */
const popularWorks = ref<Productions[]>([]);

const windowWidth = ref(0);
/**
 *
 */
const cols = computed(() => {
  if (lg(windowWidth.value)) {
    return 5;
  } if (md(windowWidth.value)) {
    return 5;
  } if (sm(windowWidth.value)) {
    return 3;
  }
  return 2;
});

const fetchData = async () => {
  const productions: Productions[] = [];

  const condition: PopularPuroductionsSearchCondition = {
    genreId: genre.value?.id,
    formId: form.value?.id,
    limit: 10,
  };
  const res = await PopularProductionService.search(condition);
  if (res) {
    res.forEach((pro) => {
      productions.push(pro.production);
    });
    popularWorks.value = productions;
  }
  // // いいね数の大きい順
  // const condition: PuroductionsSearchCondition = {
  //   genreId: genre.value?.id,
  //   formId: form.value?.id,
  //   limit: 10,
  //   orderBy: [{
  //     goodProductions: { _count: SortOrder.Desc },
  //   }],
  // };
  // const res = await ProductionService.search(condition);
  // if (res) {
  //   popularWorks.value = res;
  // }
};

watch(form, async () => {
  await fetchData();
});
watch(genre, async () => {
  await fetchData();
});

/**
 * window リサイズ時
 */
const onResize = () => {
  windowWidth.value = window.innerWidth;
};

onMounted(async () => {
  await fetchData();

  onResize();
  window.addEventListener('resize', onResize);
});

onUnmounted(() => {
  window.removeEventListener('resize', onResize);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(classes))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(SwWorksSection, {
          items: popularWorks.value,
          cols: _unref(cols),
          "column-gap": 10,
          "row-gap": 24,
          "show-rank": true
        }, null, 8, ["items", "cols"])
      ])
    ])
  ], 2))
}
}

})